export default {
  methods: {
    mergePayload(payload, additional) {
      for (let key in additional) {
        if (additional.hasOwnProperty(key)) {
          if (Object.keys(additional[key]).length > 0) {
            payload = {...payload, ...{[key]: additional[key]}};
          }
        }
      }

      return payload;
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/payload-merger.js